import { useCallback, useEffect } from 'react'
import { useSignal } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { companyUsers, userData } from '@signals'
import { BACKEND_APIS } from '@constants'


export default function useSearchAnalyticsWeekInfo() {
	const weekSearches = useSignal(0)
	const isLoadingWeek = useSignal(false)

	const getWeekInfo = useCallback(() => {
		isLoadingWeek.value = true
		postSubmit(`${BACKEND_APIS.SEARCH_ANALYTICS}/week`, {
			user: userData.value.username,
			uid: companyUsers.value
		}).then(({ searches }) => {
			isLoadingWeek.value = false
			weekSearches.value = searches
		})
	}, [JSON.stringify(companyUsers.value)])

	useEffect(() => {
		getWeekInfo()
	}, [JSON.stringify(companyUsers.value)])

	return {
		weekSearches: weekSearches.value,
		isLoadingWeek: isLoadingWeek.value
	}
}